import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, input } from '@angular/core';
import { ReplaySubject, Subject, distinctUntilChanged, takeUntil } from 'rxjs';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { CategoryView } from 'ish-core/models/category-view/category-view.model';

import { IcmCarousalContentlet } from '../../models/dot-cms-uve-contentlet.model';

import { DotCmsUveCategoryTileComponent } from './dot-cms-uve-category-tile/dot-cms-uve-category-tile.component';

// This is customized component for ICSA
@Component({
  selector: 'custom-dot-cms-category-list-manual',
  templateUrl: './dot-cms-uve-category-list-manual.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, AsyncPipe, DotCmsUveCategoryTileComponent],
})
export class DotCmsUveCategoryListManualComponent implements OnDestroy, OnInit {
  contentlet = input.required<IcmCarousalContentlet>();
  // contentlet: CustomDotCmsContentlet;
  private destroy$ = new Subject<void>();
  categoryUniqueIds: string[];
  fetchedCategories$ = new ReplaySubject<CategoryView[]>(1);
  categoriesFetched: CategoryView[];

  constructor(
    private shoppingFacade: ShoppingFacade // private accountFacade: AccountFacade, // private dotCmsFacade: DotCmsFacade
  ) {}

  ngOnInit() {
    // combineLatest([
    //   this.accountFacade.isLoggedIn$.pipe(takeUntil(this.destroy$)),
    // ]).subscribe(([contentlet, _]) => {
    //   this.categoryUniqueIds = this.contentlet().allCategories.split(',');
    //   this.getCategories(this.categoryUniqueIds);
    // });
    this.categoryUniqueIds = this.contentlet().allCategories.split(',');
    this.getCategories(this.categoryUniqueIds);
  }

  //Todo: Code refactor required
  getCategories(categoryUniqueIds: string[]) {
    const categories: Map<string, CategoryView> = new Map();
    categoryUniqueIds.forEach(uniqueId => {
      this.shoppingFacade
        .getSingleCategoryByUniqueId$(uniqueId)
        .pipe(distinctUntilChanged(), takeUntil(this.destroy$))
        .subscribe(category => {
          categories.set(uniqueId, category);
          this.categoriesFetched = [];
          categories.forEach(category => {
            this.categoriesFetched.push(category);
          });
          this.categoriesFetched = this.categoriesFetched.filter(category => category !== undefined);

          if (categories.size === categoryUniqueIds.length && this.categoriesFetched.length > 0) {
            this.fetchedCategories$.next(this.categoriesFetched);
          }
        });
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
